
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`Le 16 juin, Curevac a annoncé que, selon l'analyse intermédiaire d'un essai
clinique à grande échelle, cette efficacité n'était que de
`}<a parentName="p" {...{
        "href": "https://www.curevac.com/en/2021/06/16/curevac-provides-update-on-phase-2b-3-trial-of-first-generation-covid-19-vaccine-candidate-cvncov/"
      }}>{`47%`}</a>{`.
Une douche froide puisque le seuil minimal fixé par l'OMS est de 50%. Le
résultat est un peu meilleur chez les 18-60 ans (53%), qui sont entièrement
protégés contre l'hospitalisation et le décès. Les chercheurs ont mis en cause
le dosage du vaccin ainsi que l'apparition de variants pour expliquer ces
résultats.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;